// The React context SyncProvider fills (kept apart so hooks.ts and status.ts can read it without importing the
// provider component).

import { createContext } from 'react';
import type { SyncEngine } from './engine';
import type { FileUrls } from './files';

export interface SyncContextValue {
  engine: SyncEngine;
  files: FileUrls;
}

export const SyncContext = createContext<SyncContextValue | null>(null);
